import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { ProductsAndServices } from '@/features/clients/models/products-schema'

interface StoreInterface {
  products: ProductsAndServices[]
  setProducts: (data: ProductsAndServices[]) => void
}

export const useProductsStore = create<StoreInterface>()(
  persist(
    (set, get) => ({
      products: [],
      setProducts: (data) => {
        set({ products: [...data] })
      }
    }),
    {
      name: 'products-store'
    }
  )
)
